module.exports = __webpack_public_path__ + "assets/huafei.217a5b61.svg";